<template>
   <div v-bind:class="divModalOpenClass">
    <Loading :loading="this.loading"></Loading>
    <article v-show="!loading">
        <section class="section white-panel mb2p">
          <button v-on:click="openQrCode()" class="button button-scan" style="margin-top: 20px">車検証登録</button>
        </section>

        <section class="section white-panel mb2p">
          <h3 class="section-title" style="padding-top: 10px;">車検証情報</h3>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">自動車登録番号<br>または車両番号</dt>
            <dd class="pt8" v-if="car.plate_number">
              <p>{{car.plate_number}}</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">車検満了日</dt>
            <dd class="pt8" v-if="car.expiry_on">
              <p>{{expiryOnWareki.gengo}}{{expiryOnWareki.year}}年{{expiryOnWareki.month}}月{{expiryOnWareki.date}}日</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">初度登録年月</dt>
            <dd class="pt8" v-if="car.first_registration_on">
              <p>{{firstRegistrationOnWareki.gengo}}{{firstRegistrationOnWareki.year}}年{{firstRegistrationOnWareki.month}}月</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">車名（メーカー）</dt>
            <dd class="pt8" v-if="car.manufacturer_id">
              <p>{{manufacturerName}}</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">車両重量</dt>
            <dd class="pt8" v-if="car.weight">
              <p>{{car.weight}}kg</p>
            </dd>
          </dl>
          <div class="section" style="padding-top: 30px;">
            <button v-bind:disabled="deleteFlg" v-on:click="modalOpne()" class="button fs16 mt24 mb32 w75p">車検証を削除する</button>
            <p class="fs11 color-font2 text-center" v-if="mpSubscriptionFlag">メンテナンスパックご契約中の為、削除は出来ません。</p>
          </div>
        </section>
    </article>

    <div class="modal_overlay">
      <div class="modal_container">
        <div class="modal_body radius8 pd28 mt8p mb8p">
          <h2 class="fs18 mb4">車検証を削除します。</h2>
          <p class="fs14 line-height1_6 mb24">本当によろしいですか？</p>
          <button v-on:click="deleteApi(tsid)" class="button fs16 w100p mb12 mb0 pd16 radius200">OK</button>
          <button v-on:click="modalClose()" class="button button-gray fs16 w100p mb12 mb0 pd16 radius200">キャンセル</button>
        </div>
        <!-- /.modal_body -->
      </div>
      <!-- /.modal_container -->
    </div>

    <a id="qrdone" v-on:click="qrdone()"></a>

    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="nativeData.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="nativeData.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="nativeData.otoken">
      <input id="ss_code" type="hidden" name="ss_code" v-bind:value="this.ssCode">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="versionData.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="versionData.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="versionData.osVersion">
      <input id="cource_id" type="hidden" name="cource_id" v-bind:value="this.courceId">
      <input id="cource_name" type="hidden" name="cource_name" v-bind:value="this.courceName">
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import profileApi from '@/store/Api/Common/profile'
import carApi from '@/store/Api/car'
import cmsCarCopyApi from '@/store/Api/Common/cmsCarCopy'
import manufacturerApi from '@/store/Api/manufacturers'
import Loading from '@/views/v2/Loading.vue'
import modal from '@/assets/v2/modal'
import userInfo from '@/store/Api/Common/userInfo'
import updateCar from '@/store/Api/MaintenancePack/updateCar'
import subscription from '@/store/Api/MaintenancePack/subscription'
import config from '@/v2/config'

export default {
  data: () => ({
    loading: true,
    divModalOpenClass: 'content-wrapper',
    profileInfo: [],
    carTypes: [],
    manufacturers: [],
    tsid: '',
    popinfoid: '',
    otoken: '',
    deleteFlg: true,
    manufacturerName: '',
    mpSubscriptionFlag: false,
    ssCode: null,
    courceId: config.MAINTENANCE_PACK_COURCE.COURCE_A.ID,
    courceName: config.MAINTENANCE_PACK_COURCE.COURCE_A.NAME
  }),
  methods: {
    ...mapActions('CAR', [
      'setCar'
    ]),
    setProfileInfo (profileInfo) {
      this.profileInfo = profileInfo
    },
    setManufacturer (manufacturers) {
      this.manufacturers = manufacturers
    },
    setUserInfo (userInfo) {
      this.userInfo = userInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    modalClose () {
      this.nativeEVENTSet('ShakenSakujyoCancelButton', 'DELETE_CANCEL', 'TAP')
      window.scrollTo(0, window.modalHeight)
      this.divModalOpenClass = 'content-wrapper'
    },
    modalOpne () {
      this.nativeEVENTSet('ShakenSakujyoButton', 'DELETE_POPUP', 'TAP')
      window.modalHeight = window.pageYOffset
      window.scrollTo(0, 0)
      this.divModalOpenClass = 'content-wrapper modal_open'
    },
    openQrCode () {
      this.nativeEVENTSet('ShakenShouQRReader', 'CAR_QR_READER', 'QR')
      /* eslint-disable no-undef */
      if ('Android' in window) {
        Android.setQRData('qrdata')
      } else if ('webkit' in window) {
        webkit.messageHandlers.setQRData.postMessage('qrdata')
      }
      /* eslint-disable no-undef */
    },
    reloadPage () {
      if (this.nativeData.otoken !== undefined) {
        this.$router.go({
          path: this.$router.currentRoute.path,
          query: {
            tsid: this.nativeData.tsid,
            otoken: this.nativeData.otoken,
            popinfo_id: this.nativeData.popinfoid,
            x_cls_app_version: this.versionData.appVersion,
            x_cls_os: this.versionData.platform,
            x_cls_os_version: this.versionData.osVersion
          },
          force: true
        })
      } else {
        this.$router.go({
          path: this.$router.currentRoute.path,
          query: {
            tsid: this.nativeData.tsid,
            popinfo_id: this.nativeData.popinfoid,
            x_cls_app_version: this.versionData.appVersion,
            x_cls_os: this.versionData.platform,
            x_cls_os_version: this.versionData.osVersion
          },
          force: true
        })
      }
    },
    // CMS車検証コピーAPI用にリクエストボディを作成します.
    makeCmsCarCopyParam (car) {
      console.log('*** makeCmsCarCopyParam start ***')
      const requestParam = {}
      requestParam.id = car.id
      requestParam.popinfo_id = car.popinfo_id
      requestParam.ss_code = this.profileInfo.best_myss.code
      requestParam.chassis_number = car.chassis_number
      requestParam.model_code = car.model_code
      requestParam.manufacturer_id = car.manufacturer_id
      requestParam.qr_row = car.qr
      requestParam.weight = car.weight
      requestParam.first_registration_on = car.first_registration_on
      requestParam.expiry_on = car.expiry_on
      requestParam.motor_model = car.motor_model
      requestParam.type_designation_number = car.type_designation_number
      requestParam.classification_division_number = car.classification_division_number

      // 本画面は車検証は手入力はなく、
      // QR読み取りのみのため、ナンバープレート、軸重、型式をQR文字列から整形する.
      const res = this.qrFormat(car.qr, car.model_code)
      requestParam.plate_number1 = res.plate_number1
      requestParam.plate_number2 = res.plate_number2
      requestParam.plate_number3 = res.plate_number3
      requestParam.plate_number4 = res.plate_number4
      requestParam.axle_load_front_front_weight = res.axle_load_front_front_weight
      requestParam.axle_load_front_back_weight = res.axle_load_front_back_weight
      requestParam.axle_load_back_front_weight = res.axle_load_back_front_weight
      requestParam.axle_load_back_back_weight = res.axle_load_back_back_weight
      requestParam.model = res.model
      console.log('*** cmsCarCopyApiPost-requestParam ***')
      console.log(requestParam)

      return requestParam
    },
    /**
    * CMS車検証コピーAPI呼び出し関数
    * @param {object} car - 車検証オブジェクト
    */
    async cmsCarCopyApiPost (car) {
      console.log('call-cmsCarCopyApi')
      await cmsCarCopyApi.post(this.nativeData, this.makeCmsCarCopyParam(car), this.appVersionMakeRequestHeder(this.versionData)).then(res => {
        console.log('*** cmsCarCopyApi-success ***')
      }).catch(e => {
        console.log('cmsCarCopyApi-error')
        console.log(e.message)
        // ユーザの操作を妨げることになるためCMSコピーに失敗した場合でもErrorModalは表示しない.
      }).then(() => {
        this.reloadPage()
      })
    },
    /**
    * 車検証作成API呼び出し関数
    */
    async carApiPost () {
      console.log('call-carApiPost')
      await carApi.post(this.car).then(res => {
        this.car.id = res.data
        console.log('*** carApi-success ***')
      }).catch(e => {
        console.log('carApiPost-error')
        console.log(e.message)
      })
    },
    /**
    * ユーザー情報取得API呼び出し関数
    */
    async userInfoApiGet () {
      // ユーザー情報取得
      console.log('call-userInfoApiGet')
      await userInfo.get(this.nativeData, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
        this.setUserInfo(res.data.body.id)
        console.log('*** userInfoApiGet-success ***')
      }).catch(e => {
        console.log('userInfo-error')
        console.log(e)
        this.openErrorModal('エラーが発生しました。')
      })
    },
    /**
    * 車検証情報更新API呼び出し関数
    */
    async updateCarApiPut () {
      // 車検証情報更新API
      console.log('call-updateCarApiPut')
      const updateCarApiParam = {
        authid: this.userInfo.authid,
        ss_code: this.profileInfo.best_myss.code,
        car_id: this.car.id,
        expiry_on: this.car.expiry_on,
        chassis_number: this.car.chassis_number
      }
      await updateCar.put(updateCarApiParam).then(res => {
        console.log('*** updateCar-success ***')
      }).catch(e => {
        console.log('updateCar-error')
        console.log(e)
        this.openErrorModal('エラーが発生しました。')
      })
    },
    async subscriptionApiGet () {
      // メンテパック申込情報取得
      console.log('call-subscriptionApiGet')
      const queryParameter = `?authid=${this.userInfo.authid}`
      await subscription.get(queryParameter).then(res => {
        console.log(res.data)
        if (res.data[0]) {
          // 削除ボタンの非活性化
          this.deleteFlg = true
          // メンテパック契約中の場合、削除できません文言表示
          this.mpSubscriptionFlag = true
        }
        console.log('*** subscriptionApiGet-success ***')
      }).catch(e => {
        console.log('subscription-error')
        console.log(e.message)
        this.openErrorModal('エラーが発生しました。')
      })
    },
    deleteApi (tsid) {
      this.nativeEVENTSet('ShakenSakujyoOKButton', 'DELETE_OK', 'TAP')
      carApi.delete(tsid).then(res => {
        if (res.status === 200) {
          this.reloadPage()
        } else {
          throw Error
        }
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    async qrdone () {
      const qr = window.QR_DATA.body
      this.car.plate_number = qr.plate_number
      this.car.chassis_number = qr.chassis_number
      this.car.motor_model = qr.motor_model
      this.car.type_designation_number = qr.type_designation_number
      this.car.classification_division_number = qr.classification_division_number
      this.car.model_code = qr.model_code
      this.car.model_name = qr.model_name
      this.car.manufacturer_id = qr.manufacturer_id
      this.car.manufacturer_name = qr.manufacturer_name
      this.car.weight = qr.weight
      this.car.mileage = 1
      this.car.qr = qr.qr_data
      this.car.expiry_on = qr.expiry_on
      this.car.first_registration_on = qr.first_registration_on
      this.setCar(this.car)
      try {
        // 車検証作成APIをコール
        await this.carApiPost()
        // ユーザー情報取得APIをコール
        await this.userInfoApiGet()
        // ログインユーザーであれば車検証更新APIをコール
        if (this.userInfo.authid) {
          await this.updateCarApiPut()
        }
        // CMS車検証コピーAPIをコール
        await this.cmsCarCopyApiPost(this.car)
      } catch {
        console.log('qrdone-error')
        this.openErrorModal('エラーが発生しました。')
      }
    }
  },
  computed: {
    ...mapGetters('CAR', [
      'car'
    ]),
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfo_id
      getData.otoken = this.$route.query.otoken
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version ? this.$route.query.x_cls_app_version : '0.0.0'
      getData.platform = this.$route.query.x_cls_os ? this.$route.query.x_cls_os : 'iRidge'
      getData.osVersion = this.$route.query.x_cls_os_version ? this.$route.query.x_cls_os_version : '0.0'
      return getData
    }
  },
  async mounted () {
    this.deleteFlg = true
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false
    // 見積もりIDを引数にセットする
    this.tsid = this.$route.query.tsid
    this.popinfoid = this.$route.query.popinfo_id
    this.otoken = this.$route.query.otoken

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // profile情報マスタ取得。
    await profileApi.get(this.tsid, this.otoken, this.appVersionMakeRequestHeder(this.versionData)).then(res => {
      this.setProfileInfo(res.data.body)
    }).catch(e => {
      console.log('profile-error')
      console.log(e.message)
      if (!isApiError) {
        console.log('profileApi-error')
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturerApi.get().then(res => {
      this.setManufacturer(res.data.manufacturer)
    }).catch(e => {
      if (!isApiError) {
        console.log('manufacturerApi-error')
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await carApi.get(this.tsid).then(res => {
      // 車検証データがtsidに紐づき存在する且つQR登録されている場合
      if (res.data.car.length > 0) {
        for (let i = 0; i < res.data.car.length; i++) {
          if (res.data.car[i].type_designation_number) {
            this.setCar(res.data.car[i])
            // 初度登録年月を和暦に変換
            this.firstRegistrationOnWareki = this.toWareki(this.car.first_registration_on)
            // 車検満了日を和暦に変換
            this.expiryOnWareki = this.toWareki(this.car.expiry_on)
            // 削除ボタンの活性化
            this.deleteFlg = false
            break
          }
        }
        this.manufacturers.forEach(element => {
          if (element.id === this.car.manufacturer_id) {
            this.manufacturerName = element.manufacturer_name
          }
        })
      }
      this.car.ts_id = this.tsid
      this.car.popinfo_id = this.popinfoid
      this.setCar(this.car)
    }).catch(e => {
      if (!isApiError) {
        console.log('carApi-error')
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // ユーザー情報取得
    await this.userInfoApiGet()

    if (this.userInfo.authid) {
      // メンテパック申込情報取得
      await this.subscriptionApiGet()
    }
    // メンテパック申込画面からの遷移の場合
    this.ssCode = this.profileInfo.best_myss.code
    if (this.$route.query.fromApply) {
      sessionStorage.from_apply = this.$route.query.fromApply
    }

    if (!isApiError) {
      this.loading = false
    }
    // [eventTrack] 車検証登録画面表示完了
    this.nativePVset('SHAKENTOUROKU')
  },
  components: {
    Loading
  }
}
</script>
